export default __webpack_public_path__ + "static/media/favicon.65046e49.ico";